
export const setNumber = (num, precision = 2) => {
    return +Number.parseFloat(num).toFixed(precision);
};

export const isFloat = num => !!(num % 1);
